import React, { useEffect, useState } from 'react';
import styles from './change-categories.module.scss';
import { DefaultButton, MiniInput } from 'shared/ui';
import { businessStore } from 'entities/index';
import { BookingApi } from 'shared/api';
import { IServiceCategory } from 'shared/api/booking/interfaces/service-categories.interface';
import { observer } from 'mobx-react';

interface IChangeCategoriesProps {
  onClose?: () => void;
  onSuccess?: (message: string) => void;
}

export const ChangeCategories: React.FC<IChangeCategoriesProps> = observer(
  ({ onClose, onSuccess }) => {
    const pointId = businessStore.pointId;
    const [category, setCategory] = useState<IServiceCategory>({
      id: '',
      category: '',
    });
    const [newCategoryName, setNewCategoryName] = useState<string>('');
    const [validationError, setValidationError] = useState('');

    useEffect(() => {
      if (pointId) {
        businessStore.initServiceCategories(pointId);
      }
    }, []);
    const clearError = () => {
      setValidationError('');
    };
    const handleSubmitDelete = (
      e: React.MouseEvent<HTMLDivElement, MouseEvent>
    ) => {
      try {
        if (pointId && category.id) {
          BookingApi.deleteServiceCategory({
            categoryId: category.id,
          }).then(() => {
            businessStore.initServiceCategories(pointId);
            onSuccess?.('Категория успешно удалена');
            onClose?.();
          });
          return;
        } else if (!category.id) {
          setValidationError('Выберите категорию для удаления');
        }
      } catch (error) {
        if (error instanceof Error) {
          setValidationError(error.message);
        }
        e.stopPropagation();
      }
      e.stopPropagation();
    };
    const handleSubmitUpdate = (
      e: React.MouseEvent<HTMLDivElement, MouseEvent>
    ) => {
      try {
        if (pointId && category.id && newCategoryName) {
          BookingApi.updateServiceCategory({
            categoryId: category.id,
            category: newCategoryName,
          }).then(() => {
            businessStore.initServiceCategories(pointId);
            onSuccess?.('Категория успешно изменена');
            onClose?.();
          });
          return;
        } else if (!category.id) {
          setValidationError('Выберите категорию для изменения');
        } else if (!newCategoryName) {
          setValidationError('Введите название категории');
        }
      } catch (error) {
        if (error instanceof Error) {
          setValidationError(error.message);
        }
        e.stopPropagation();
      }
      e.stopPropagation();
    };

    return (
      <div
        className={styles.change_categories__container}
        onClick={(e) => {
          if ((e.target as HTMLElement).closest(`.${styles.buttons__button}`)) {
            return;
          }
          e.stopPropagation();
        }}
      >
        <div className={styles.container__title}>Изменить Категорию</div>
        <div className={styles.container__categories}>
          <div className={styles.categories__input} onClick={clearError}>
            <MiniInput
              inputValue={category.category}
              inputTitle="Категория"
              inputPlaceholder="Выберите категорию"
              inputType="text"
              onChange={setCategory}
              className={styles.input_category}
              options={businessStore.serviceCategories}
            />
          </div>
          <div className={styles.categories__input} onClick={clearError}>
            <MiniInput
              placeholder="Новое название категории"
              inputTitle="Название"
              inputValue={newCategoryName}
              onChange={(value) => setNewCategoryName(value)}
            />
          </div>
        </div>
        <div className={styles.content__error}>{validationError}</div>

        <div className={styles.container__buttons}>
          <div
            className={styles.buttons__button}
            onClick={(e) => {
              try {
                handleSubmitDelete(e);
              } catch (error) {
                console.error('Error:', error);
              }
            }}
          >
            <DefaultButton
              buttonText="Удалить"
              className={styles.button_action}
              color="red"
            />
          </div>
          <div
            className={styles.buttons__button}
            onClick={(e) => {
              try {
                handleSubmitUpdate(e);
                return;
              } catch (error) {
                console.error('Error:', error);
              }
            }}
          >
            <DefaultButton
              buttonText="Обновить"
              className={styles.button_action}
              color="green"
            />
          </div>
        </div>
      </div>
    );
  }
);
